import React, { useEffect, useState } from "react";
import { ILabel } from "../../../../shared/interface/label";
import { routes } from "../../helpers/router.helper";
import { SubCategoryListController } from "../SubCategoryList";
import content from "../../cms/accordion.json";
import { AccordionGroup, IAccordion } from "./Accordion";

interface IAccordionControllerProps {
  subCategories: ILabel[];
  category: string;
}

export const AccordionController = ({
  subCategories,
  category,
}: IAccordionControllerProps) => {
  const [accordions, setAccordions] = useState<IAccordion[]>([]);

  useEffect(() => {
    const mapped = subCategories.map((subCategory, index) => ({
      label: subCategory.displayName,
      href: routes.subCategory(category, subCategory.name),
      child: (
        <SubCategoryListController
          labelId={subCategory.labelId}
          categorySlug={category}
          subcategorySlug={subCategory.name}
          max={content.maxSubAccordion}
          showMoreLink={{
            title: content.showAllArticlesLabel,
            route: routes.subCategory(category, subCategory.name),
          }}
          data-id={`sub-accordion-${index}`}
        />
      ),
    }));
    setAccordions([...mapped]);
  }, [subCategories, category]);

  return <AccordionGroup accordions={accordions} />;
};
